/* src/app/app.component.css */
.main-content {
  position: relative;
}
.content {
  width: 100%;
  height: 100%;
}
/*# sourceMappingURL=app.component.css.map */
